import { useEffect, useMemo, useState } from 'react';
import { Files } from '../../../services/journey.service';
import FileListPageModel from './model';

interface Props {
  files: Files | null;
  category: string;
}

export default function FileListPageViewModel({ files, category }: Props) {
  const [selectedYear, setSelectedYear] = useState<string | null>(null);
  const currentYear = new Date().getFullYear().toString();

  const categoryFiles = useMemo(() => FileListPageModel.resolveCategory(files, category), [files, category]);

  const sorted = useMemo(() => FileListPageModel.sortByDate(categoryFiles), [categoryFiles]);
  const filtered = useMemo(
    () => (selectedYear ? FileListPageModel.filterByYear(sorted, selectedYear) : sorted),
    [sorted, selectedYear]
  );
  const years = useMemo(() => FileListPageModel.extractYears(sorted), [sorted]);

  useEffect(() => {
    if (years.length > 0 && selectedYear === null) {
      setSelectedYear(years.includes(currentYear) ? currentYear : null);
    }
  }, [years]);

  const handleYearChange = (year: string) => {
    setSelectedYear(prev => (prev === year ? null : year));
  };

  return {
    visibleFiles: filtered,
    years,
    selectedYear,
    setSelectedYear: handleYearChange,
    pageTitle: FileListPageModel.resolveTitle(category),
    isEmpty: filtered.length === 0
  };
}
